var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceledHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#C11313",
    strokeDasharray: "0.5 0.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6307 5.4139C13.0857 4.89474 13.8605 4.85915 14.3613 5.3344C14.862 5.80966 14.899 6.61579 14.444 7.13494L12.042 9.87528L14.3937 12.5582C14.8487 13.0774 14.8117 13.8835 14.311 14.3588C13.8102 14.834 13.0354 14.7984 12.5804 14.2793L10.3811 11.7702L8.18204 14.279C7.72699 14.7982 6.95219 14.8338 6.45146 14.3585C5.95074 13.8833 5.91371 13.0772 6.36876 12.558L8.72021 9.87528L6.31847 7.13518C5.86342 6.61602 5.90045 5.8099 6.40117 5.33464C6.9019 4.85939 7.67671 4.89498 8.13175 5.41414L10.3811 7.98039L12.6307 5.4139Z",
    fill: "#C11313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceledHistory);
export default __webpack_public_path__ + "static/media/canceled_history.7889edf7234e819ed0c96efabe2d307d.svg";
export { ForwardRef as ReactComponent };